export const PageTitle = ({ kicker, title, children }) => (
  <div className="px-5 lg:px-12 pt-12 sm:pt-16 pb-8 sm:pb-10 reveal">
    <p className="font-cond uppercase tracking-[0.35em] text-xs sm:text-sm text-lime mb-3">{kicker}</p>
    <h1 data-testid="page-title" className="font-gothic text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">{title}</h1>
    {children && <div className="mt-5 max-w-2xl text-slate-400 text-sm sm:text-base">{children}</div>}
  </div>
);
